//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('../../assets/scss/loading.scss');
require('../../assets/scss/common/reset.scss');

export default {
    computed: {
        loadingShow() {
            return this.$store.state.loadingShow;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/common/mfyLoading.vue